/* BrComfy quiz signup popup.
   Step 1 who it's for → step 2 email (Klaviyo email list) → step 3 phone (Klaviyo SMS list) → step 4 code.
   Opens after a delay, at 35% scroll, or on desktop exit intent. Remembers state in localStorage "brc-pop". */
(function () {
  'use strict';
  var pop = document.getElementById('brc-pop');
  if (!pop) return;
  var teaser = document.getElementById('brc-pop-teaser');
  var KEY = 'brc-pop', DAY = 864e5, REVISION = '2026-07-15';
  var cfg = pop.dataset, design = cfg.design === 'true';
  var data = { for: '', email: '', phone: '' };

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(load(), v))); } catch (e) {} }
  var st = load();

  /* ---------- open / close ---------- */
  var lastFocus = null, opened = false;
  function lock(on) { if (window.BRC && BRC.lock) BRC.lock(on); else document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function open() {
    if (!pop.hidden) return;
    opened = true; lastFocus = document.activeElement;
    if (pop.parentElement !== document.body) document.body.appendChild(pop);
    pop.hidden = false; void pop.offsetWidth; pop.classList.add('is-open');
    if (teaser) teaser.hidden = true;
    lock(true);
    var first = pop.querySelector('.brc-pop__step:not([hidden]) button, .brc-pop__step:not([hidden]) input');
    if (first) first.focus({ preventScroll: true });
  }
  function close(reason) {
    pop.classList.remove('is-open'); lock(false);
    setTimeout(function () { pop.hidden = true; }, 380);
    if (reason !== 'done') { save({ s: 'dismissed', t: Date.now() }); showTeaser(); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function showTeaser() { if (teaser && load().s !== 'subscribed' && !load().noTeaser) teaser.hidden = false; }

  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-brc-pop-close]')) { e.preventDefault(); close(data.email ? 'done' : 'dismiss'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) close(data.email ? 'done' : 'dismiss');
    if (e.key === 'Tab' && !pop.hidden) { // keep focus inside the dialog
      var f = [].slice.call(pop.querySelectorAll('button, a[href], input, select')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  if (teaser) teaser.addEventListener('click', function (e) {
    if (e.target.closest('[data-brc-pop-teaser-x]')) { teaser.hidden = true; save({ noTeaser: true }); return; }
    open();
  });

  /* ---------- steps ---------- */
  function go(n) {
    pop.querySelectorAll('.brc-pop__step').forEach(function (el) { el.hidden = el.dataset.step !== String(n); });
    pop.querySelectorAll('.brc-pop__progress i').forEach(function (i, k) { i.classList.toggle('on', k < Math.min(n, 3)); });
    pop.classList.toggle('is-done', n === 4);
    var f = pop.querySelector('.brc-pop__step[data-step="' + n + '"] input:not([type=hidden]), .brc-pop__step[data-step="' + n + '"] button');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function err(form, msg) { var el = form.querySelector('.brc-pop__err'); el.textContent = msg || ''; el.hidden = !msg; }
  function busy(form, on) { var b = form.querySelector('button[type=submit]'); if (b) { b.disabled = on; b.classList.toggle('is-loading', on); } }

  pop.querySelectorAll('[data-brc-pop-for]').forEach(function (b) {
    b.addEventListener('click', function () {
      data.for = b.dataset.brcPopFor;
      var gift = data.for === 'gift';
      pop.querySelector('[data-brc-pop-for-label]').textContent = gift ? 'For them' : 'For you';
      pop.querySelector('[data-brc-pop-sub-me]').hidden = gift;
      pop.querySelector('[data-brc-pop-sub-gift]').hidden = !gift;
      go(2);
    });
  });

  /* ---------- Klaviyo ---------- */
  // POST to Klaviyo's client API; retries twice on network errors / 5xx (Klaviyo returns 202 on success)
  function kpost(path, body, tries) {
    tries = tries || 0;
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(cfg.key), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION }, body: JSON.stringify(body), keepalive: true
    }).then(function (r) {
      if (r.status >= 500 && tries < 2) return new Promise(function (res) { setTimeout(res, 700 * (tries + 1)); }).then(function () { return kpost(path, body, tries + 1); });
      return { ok: r.status >= 200 && r.status < 300, status: r.status };
    }, function (e) {
      if (tries < 2) return new Promise(function (res) { setTimeout(res, 700 * (tries + 1)); }).then(function () { return kpost(path, body, tries + 1); });
      return { ok: false, status: 0, blocked: true };
    });
  }
  function subscribe(profileAttrs, listId, source) {
    if (!cfg.key) return Promise.resolve({ ok: true, skipped: true });
    var body = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: profileAttrs } } } } };
    if (listId) body.data.relationships = { list: { data: { type: 'list', id: listId } } };
    return kpost('subscriptions', body);
  }
  function upsertProfile(attrs) {
    if (!cfg.key) return Promise.resolve({ ok: true });
    return kpost('profiles', { data: { type: 'profile', attributes: attrs } });
  }
  function identify(attrs) { try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify(attrs); } catch (e) {} }
  function shopifyNewsletter(email) {
    // best effort: also add the subscriber to Shopify customers, tagged with the quiz answer
    try {
      var fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter,popup,shopping-for-' + (data.for || 'me') + (cfg.mode === 'vip' ? ',bf-vip' : ''));
      fetch('/contact#brc-pop', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    } catch (e) {}
  }

  var props = function () { var p = { shopping_for: data.for || 'me', signup_source: 'Quiz popup', signup_page: location.pathname }; if (cfg.mode === 'vip') p.bf_early_access = true; if (cfg.mode === 'sale') p.bf_sale_alerts = true; return p; };

  var emailForm = pop.querySelector('[data-step="2"]');
  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = emailForm.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err(emailForm, 'Please enter a valid email address.'); return; }
    err(emailForm, ''); busy(emailForm, true);
    data.email = email;
    subscribe({ email: email, properties: props(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }, cfg.emailList, 'Quiz popup (email)')
      .then(function (r) {
        busy(emailForm, false);
        if (!r.ok) { err(emailForm, r.blocked ? 'We couldn\'t reach our sign-up service. If you use an ad blocker, pause it for this site and try again.' : 'Something went wrong on our side. Please try again in a moment.'); return; }
        identify({ email: email });
        save({ s: 'subscribed', t: Date.now() });
        if (window.dataLayer) window.dataLayer.push({ event: 'brc_signup_email', shopping_for: data.for });
        if (window.fbq) try { window.fbq('track', 'Lead', { content_name: 'Quiz popup' }); } catch (x) {}
        go(3);
      })
      .catch(function () { busy(emailForm, false); err(emailForm, 'Something went wrong. Please try again.'); });
  });

  function e164(cc, raw) {
    var d = (raw || '').replace(/[^\d+]/g, '');
    if (d.indexOf('+') === 0) return d;
    if (d.indexOf('00') === 0) return '+' + d.slice(2);
    d = d.replace(/^0+/, '');
    return cc + d;
  }
  var smsForm = pop.querySelector('[data-step="3"]');
  smsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var phone = e164(smsForm.cc.value, smsForm.tel.value);
    var digits = phone.replace(/\D/g, '');
    if (digits.length < 9 || digits.length > 15) { err(smsForm, 'Please enter a valid mobile number.'); return; }
    err(smsForm, ''); busy(smsForm, true);
    data.phone = phone;
    var attrs = { email: data.email, phone_number: phone, properties: props(), subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
    // 1) SMS consent (only takes effect once Klaviyo SMS is set up for the number's country)
    // 2) always store the number on the profile as well, so it is never lost
    Promise.all([
      subscribe(attrs, cfg.smsList, 'Quiz popup (sms)'),
      upsertProfile({ email: data.email, phone_number: phone, properties: Object.assign(props(), { signup_phone: phone, sms_opt_in: true, sms_opt_in_at: new Date().toISOString() }) })
    ])
      .then(function (res) {
        if (!res[0].ok && !res[1].ok) { busy(smsForm, false); err(smsForm, 'We couldn\'t save your number. Please try again.'); return; }
        busy(smsForm, false);
        identify({ email: data.email, phone_number: phone });
        save({ s: 'subscribed', sms: true, t: Date.now() });
        if (window.dataLayer) window.dataLayer.push({ event: 'brc_signup_sms' });
        done(true);
      })
      .catch(function () { busy(smsForm, false); err(smsForm, 'Something went wrong. Please try again.'); });
  });
  var skip = pop.querySelector('[data-brc-pop-skip]');
  if (skip) skip.addEventListener('click', function () { done(false); });

  function done(sms) {
    pop.querySelector('[data-brc-pop-done-sms]').hidden = !sms;
    pop.querySelector('[data-brc-pop-done-email]').hidden = sms;
    go(4);
    // apply the code to this browser's cart session in the background
    if (cfg.code) fetch('/discount/' + encodeURIComponent(cfg.code), { credentials: 'same-origin' }).catch(function () {});
  }
  var copy = pop.querySelector('[data-brc-pop-copy]');
  if (copy) copy.addEventListener('click', function () {
    var code = cfg.code;
    var ok = function () { copy.querySelector('small').textContent = 'Copied'; setTimeout(function () { copy.querySelector('small').textContent = 'Tap to copy'; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
  });
  var nameForm = pop.querySelector('[data-brc-pop-name]');
  if (nameForm) nameForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var fn = nameForm.first_name.value.trim(); if (!fn) return;
    upsertProfile({ email: data.email, first_name: fn });
    identify({ email: data.email, first_name: fn });
    nameForm.innerHTML = '<p class="brc-pop__p">Nice to meet you, ' + fn.replace(/[<>&"]/g, '') + '.</p>';
  });

  /* ---------- triggers ---------- */
  if (design) return; // never auto-open in the theme editor
  if (st.s === 'subscribed') return;
  var recentlyDismissed = st.s === 'dismissed' && Date.now() - (st.t || 0) < 3 * DAY;
  if (recentlyDismissed) { showTeaser(); return; }
  var delay = (parseInt(cfg.delay, 10) || 8) * 1000;
  var timer = setTimeout(open, delay);
  function onScroll() {
    var sc = (window.BRC && BRC.scroller && BRC.scroller()) || document.scrollingElement;
    var max = sc.scrollHeight - sc.clientHeight;
    if (max > 0 && sc.scrollTop / max > 0.35 && !opened) { clearTimeout(timer); open(); document.removeEventListener('scroll', onScroll, true); }
  }
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!opened && !e.relatedTarget && e.clientY < 8) { clearTimeout(timer); open(); }
    });
  }
})();
